import { render, staticRenderFns } from "./child-task-bioazhu.vue?vue&type=template&id=1e1c07a3&scoped=true&"
import script from "./child-task-bioazhu.vue?vue&type=script&lang=ts&"
export * from "./child-task-bioazhu.vue?vue&type=script&lang=ts&"
import style0 from "./child-task-bioazhu.vue?vue&type=style&index=0&id=1e1c07a3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1c07a3",
  null
  
)

export default component.exports